<template>
  <v-card>
    <v-card-title class="text-h5 grey lighten-2">
      License
    </v-card-title>
    <v-text-field
      v-model="license_id"
      label="Unique license id"
      v-bind:readonly="license.license_id != null"
      required
    ></v-text-field>
    <v-text-field
      v-model="company"
      label="Company name"
      v-bind:readonly="readonly"
    ></v-text-field>
    <v-text-field
      v-model="description"
      label="description"
      v-bind:readonly="readonly"
    ></v-text-field>
    <v-text-field
      prepend-icon="mdi-email"
      v-model="contact"
      label="Company contact email"
      v-bind:readonly="readonly"
    ></v-text-field>
    <v-text-field
      prepend-icon="mdi-email"
      v-model="internal_contact"
      label="Internal contact email"
      v-bind:readonly="readonly"
    ></v-text-field>
    <v-menu
      ref="menu1"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="start"
          label="Start"
          v-bind:readonly="readonly"
          persistent-hint
          prepend-icon="mdi-calendar"
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="start"
        no-title
      ></v-date-picker>
    </v-menu>
    <v-menu
      ref="menu2"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="end"
          label="End"
          v-bind:readonly="readonly"
          persistent-hint
          prepend-icon="mdi-calendar"
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="end"
        no-title
      ></v-date-picker>
    </v-menu>
    <v-select
      v-model="license_type"
      :items="license_types"
      label="License Type"
      v-bind:readonly="readonly"
    ></v-select>
    <v-text-field
      v-if="isOnPrem"
      v-model="num_processes"
      label="number of processes (for on premise)"
      type="number"
      v-bind:readonly="readonly"
    ></v-text-field>
    <v-text-field
      v-if="isOnPrem"
      v-model="host_id"
      label="host id of license server (on premise)"
      v-bind:readonly="readonly"
    ></v-text-field>
    <v-text-field
      v-if="isLite"
      v-model="num_licenses"
      label="number of licenses (for lite apps on cloud)"
      type="number"
      v-bind:readonly="readonly"
    ></v-text-field>
    <v-select
      v-model="applications"
      :items="all_applications"
      label="Allowed apps"
      multiple
      chips
      persistent-hint
      v-bind:readonly="readonly"
    ></v-select>
    <v-combobox
      v-model="members"
      label="User emails"
      multiple
      chips
      v-bind:readonly="readonly"
    ></v-combobox>
    <v-divider></v-divider>
    <v-card-actions v-if="edit">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        text
        @click="submit"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'License',
  components: {
  },
  data() {
    return {
      license_id: this.license.license_id,
      company: this.license.company,
      description: this.license.description,
      contact: this.license.contact,
      internal_contact: this.license.internal_contact,
      start: this.license.start,
      end: this.license.end,
      start_timestamp: null,
      end_timestamp: null,
      license_type: this.license.type,
      num_processes: this.license.num_processes,
      host_id: this.license.host_id,
      num_licenses: this.license.num_licenses,
      members: this.license.members,
      applications: this.license.applications,
    }
  },
  computed: {
    // a computed getter
    isOnPrem: function () {
      // `this` points to the vm instance
      return ["ONPREMISE_EXPERT", "ONPREMISE_EXPERT_PLUS"].includes(this.license_type)
    },
    isLite: function () {
      // `this` points to the vm instance
      return this.license_type == "LITE"
    },
  },
  props: ['license', 'all_applications', 'license_types', 'readonly', 'edit'],
  methods: {
    submit() {
      var license = {
        license_id: this.license_id,
        company: this.company,
        description: this.description,
        contact: this.contact.toLowerCase(),
        internal_contact: this.internal_contact.toLowerCase(),
        start: new Date(this.start).toISOString(),
        end: new Date(this.end).toISOString(),
        type: this.license_type,
        members: this.members.map(s=>s.toLowerCase()),
        applications: this.applications,
      };
      if (this.isOnPrem) {
        license.num_processes = this.num_processes;
        license.host_id = this.host_id;
      } else if (this.isLite) {
        license.num_licenses = this.num_licenses;
      }
      this.$emit('OnSubmit', license)
    },
    reset() {
      this.license_id = null;
      this.company = null;
      this.description = null;
      this.contact = null;
      this.internal_contact = null;
      this.start = null;
      this.end = null;
      this.license_type = null;
      this.members = null;
      this.applications = null;
      this.num_processes = null;
      this.num_licenses = null;
      this.host_id = null;
    }

  },
}
</script>
